import { Component, OnInit, Inject, ViewChild, forwardRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { APIService } from '../../providers/api.service';

@Component({
  selector: 'app-view-selection-popup',
  templateUrl: './view-selection-popup.component.html',
  styleUrls: ['./view-selection-popup.component.css']
})
export class ViewSelectionPopupComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ViewSelectionPopupComponent>, private APIService: APIService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.contestName = this.data.details;
    this.cont_Id = this.data.details.contestId
    this.user_ID = this.data.userID;
    this.user_Name = this.data.userName;
  }

  cont_Id
  contestName;
  user_Name;
  tournament;
  gameId;
  user_ID;
  userList = {
    completed: [],
    inprogress: []
  };

  ngOnInit() {
    var self = this
    self.APIService.doApiCall(function (data) {
      self.tournament = data.Data;
      self.APIService.doApiCall(function (data1) {
        $("html").addClass("cdk-global-scrollblock")
        for (var i = 0; i < data1.Data.length; i++) {
          if (data1.Data[i].statusId === 11 || data1.Data[i].statusId === 4) {
            self.gameId = data1.Data[i].professionalGamesId;
            self.getSelectedStatements(data1.Data[i]);
          }
        }
      }, 'api/tournament/published/professionalgames/list/' + data.Data.tournamentId + '?page=&limit=', 'GET', null, null);
    }, 'api/contest/' + self.cont_Id, 'GET', null, null);
  }

  close() {
    this.dialogRef.close();
  }

  getSelectedStatements(game) {
    var self = this
    self.APIService.doApiCall(function (data) {
      game.statementList = data.Data;
      console.log('Statement data:', data.Data); // Debug: check if comments exist
      if (game.statusId === 11) {
        self.userList.completed.push(game);
      } else if (game.statusId === 4) {
        self.userList.inprogress.push(game);
      }
    }, 'api/statement/select/user/' + self.user_ID + '/professionalgames/' + game.professionalGamesId + '/contest/' + self.cont_Id, 'GET', null, null);

  }
  
  test = "This is a test tooltip"; // Test property
}
